<template>
  <div id="not-found">
    <div class="container">
      <h1>Page introuvable</h1>
      <p>La page à laquelle vous tentez d'accéder n'existe pas.</p>
      <router-link :to="{ name: 'Home'}" class="btn btn-primary">Retourner à l'accueil</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  #not-found {
    justify-content: center;
    align-items: center;
    text-align: center;
    display: flex;
    width: 100%;

    h1 {
      margin-bottom: 1rem;
    }

    .btn {
      margin: 2rem auto auto;
    }
  }
</style>
